import { parsePhoneNumberFromString } from 'libphonenumber-js/core';
import metadata from '../../../metadata.min.json';

export const maskEmail = email => (!email ? '' : `${email.charAt(0)}xxxx@${email.split('@').pop()}`);

export const maskPhoneNumber = (phone) => {
  if (!phone) {
    return '';
  }
  const parsed = parsePhoneNumberFromString(phone, metadata);
  if (!parsed) {
    return `xxxxxx${phone.substr(-4)}`;
  }

  return `+${parsed.countryCallingCode}xxxxxx${parsed.nationalNumber.substr(-4)}`;
};

export const getLast4DigitsPhone = (phone) => {
  if (!phone) {
    return '';
  }
  const parsed = parsePhoneNumberFromString(phone, metadata);
  if (!parsed) {
    return phone.substr(-4);
  }
  return parsed.nationalNumber.substr(-4);
};
